module.exports = __webpack_public_path__ + "media/scanner/corner-down-right-82ad881f.png";